import React, { useEffect, useState } from 'react'
import { FilterManager, IBaseFilters } from '../../../../../../common/filter/FilterManager'
import { useAuth } from '../../../../../auth'
import { getListMerchantsForSelect } from '../../../../../../common/core/_requests'
import { getPaymentMethods } from '../../../../api/getPaymentMethods'
import { CommissionRulesQuery } from '../../core/query.types'
import {
  CashboxKind,
  CommissionCurrency,
  CommissionDirection,
  CURRENCY_LABELS,
  DIRECTION_LABELS,
  KIND_LABELS,
} from '../../core/consts'

interface CommissionFilters extends IBaseFilters {
  direction?:     string
  currency?:      string
  merchantToken?: string
  cashboxKind?:   string
  paymentMethod?: string
  isDefault?:     '' | 'default' | 'custom'
}

type Option = { value: string; label: string }

const directionOptions = Object.entries(DIRECTION_LABELS).map(([value, label]) => ({ value, label }))
const currencyOptions  = Object.entries(CURRENCY_LABELS).map(([value, label]) => ({ value, label }))
const kindOptions      = Object.entries(KIND_LABELS).map(([value, label]) => ({ value, label }))
const isDefaultOptions = [
  { value: 'default', label: 'Системное' },
  { value: 'custom',  label: 'Пользовательское' },
]

// Static empty defaults — reset must clear to this, not to the last applied query.
const DEFAULT_FILTER_VALUES: CommissionFilters = {
  direction:     '',
  currency:      '',
  merchantToken: '',
  cashboxKind:   '',
  paymentMethod: '',
  isDefault:     '',
}

interface Props {
  onChange: (next: CommissionRulesQuery) => void
}

const CommissionRulesFilters: React.FC<Props> = ({ onChange }) => {
  const { currentUser } = useAuth()
  const [merchantOptions, setMerchantOptions]     = useState<Option[]>([])
  const [paymentOptions, setPaymentOptions]       = useState<Option[]>([])

  useEffect(() => {
    let cancelled = false

    getListMerchantsForSelect(currentUser)
      .then((resp) => {
        if (cancelled || !resp.data?.success) return
        const list = resp.data.merchants ?? []
        setMerchantOptions(list.map((m) => ({ value: m.token, label: m.title })))
      })
      .catch(() => setMerchantOptions([]))

    getPaymentMethods()
      .then((resp: any) => {
        if (cancelled || !resp?.data?.success) return
        const list = resp.data.paymentMethods ?? []
        setPaymentOptions(list.map((pm: any) => ({ value: pm.type, label: pm.type })))
      })
      .catch(() => setPaymentOptions([]))

    return () => { cancelled = true }
  }, [currentUser])

  return (
    <FilterManager<CommissionFilters>
      activeFilters={[
        { filter: 'select', fieldName: 'direction' },
        { filter: 'select', fieldName: 'currency' },
        { filter: 'select', fieldName: 'merchantToken' },
        { filter: 'select', fieldName: 'cashboxKind' },
        { filter: 'select', fieldName: 'paymentMethod' },
        { filter: 'select', fieldName: 'isDefault' },
      ]}
      defaultValues={DEFAULT_FILTER_VALUES}
      onApplyFilters={(f) => {
        onChange({
          direction:     (f.direction     || undefined) as CommissionDirection | undefined,
          currency:      (f.currency      || undefined) as CommissionCurrency | undefined,
          merchantToken: f.merchantToken  || undefined,
          cashboxKind:   (f.cashboxKind   || undefined) as CashboxKind | undefined,
          paymentMethod: f.paymentMethod  || undefined,
          isDefault:     f.isDefault === '' || f.isDefault === undefined ? undefined : f.isDefault === 'default',
          cursor:        undefined,
        })
      }}
      filterProps={{
        direction:     { label: 'Направление',     options: directionOptions },
        currency:      { label: 'Валюта',          options: currencyOptions },
        merchantToken: { label: 'Мерчант',         options: merchantOptions },
        cashboxKind:   { label: 'Тип кассы',       options: kindOptions },
        paymentMethod: { label: 'Платёжный метод', options: paymentOptions },
        isDefault:     { label: 'Тип правила',     options: isDefaultOptions },
      }}
    />
  )
}

export default CommissionRulesFilters
